import React, { useState } from 'react';
import ManualSales from './ManualSales';
import POSSales from './POSSales';

const SalesPage = ({ menuItems, sales, onUpdateSales, onDeleteSale, recipes }) => {
  // 🔥 ahora inicia en POS
  const [view, setView] = useState('pos');

  return (
    <div className="space-y-6 mt-6">
      <div className="flex justify-center space-x-4 mb-6">
        {/* 🔥 POS primero */}
        <button
          onClick={() => setView('pos')}
          className={`${view === 'pos' ? 'bg-[#58735A] text-[#F9EFD7]' : 'bg-gray-300 text-gray-700'} py-2 px-4 rounded-md transition duration-200`}
        >
          Ventas del Punto de Venta
        </button>
        {/* 🔥 Manual después */}
        <button
          onClick={() => setView('manual')}
          className={`${view === 'manual' ? 'bg-[#58735A] text-[#F9EFD7]' : 'bg-gray-300 text-gray-700'} py-2 px-4 rounded-md transition duration-200`}
        >
          Ingreso Manual
        </button>
      </div>
      {view === 'pos' ? (
        <POSSales
          sales={sales}
          recipes={recipes}
          menuItems={menuItems}
          onDeleteSale={onDeleteSale}
        />
      ) : (
        <ManualSales
          menuItems={menuItems}
          sales={sales}
          onUpdateSales={onUpdateSales}
          recipes={recipes}
        />
      )}
    </div>
  );
};

export default SalesPage;